<template>
    <div class="check-lists" :class="draggable ? 'can-drag': ''">
        <component :is="draggable ? 'draggable' : 'div'" v-model="list" class="dragArea" v-bind="getOptions"
                   handle=".handle">
            <branch-item v-for="(branch, index) in list" :key="branch.id"
                         :value="value[index]"
                         :view="view"
                         :draggable="draggable"
                         :branch="branch"
                         :branch-actions="draggable ? personalActionsBranch : commonActionsBranch"
                         :list-actions="draggable ? personalActionsList : commonActionsList"
                         @change="changeList($event, index)"
                         @list-click="handleListClick($event)"
            ></branch-item>
        </component>
    </div>
</template>

<script>
    import DropdownItemComponent from "../common/Dropdown";
    import BranchItem from "./BrancheItem";
    import draggable from 'vuedraggable'
    import {mapActions} from "vuex";


    export default {
        name: 'branches-list',
        components: {BranchItem, DropdownItemComponent,draggable},
        props: {
            listClick: {
                type: Boolean,
                default: true
            },
            view: {
                type: Boolean,
                default: false
            },
            branchList: Array,
            draggable: {
                type: Boolean,
                default: false
            },
            value: {type: Array,
                default: () => {
                    return []
                }}
        },
        data() {
            return {
                active: 0,
                commonActionsBranch: [
                    {
                        title: 'Копировать',
                        action: 'checkLists/copyBranch'
                    },
                    /*{
                        title: 'В избранное',
                        action: 'copy'
                    },*/
                ],
                commonActionsList: [
                   /* {
                        title: 'Копировать',
                        action: 'copy'
                    },*/
                    {
                        title: 'В избранное',
                        action: 'checkLists/setFavorite'
                    },
                ],
                personalActionsBranch: [
                    {
                        title: 'Редактировать',
                        action: 'checkLists/editBranch'
                    },
                    {
                        title: 'Копировать',
                        action: 'checkLists/copyBranch'
                    },
                   /* {
                        title: 'В избранное',
                        action: 'copy'
                    },*/
                    {
                        title: 'Удалить',
                        action: 'checkLists/deleteBranch',
                        needConfirm: true,
                        textConfirm: "Вы уверены, что хотите удалить ветку?"
                    },
                ],
                personalActionsList: [
                    /*{
                        title: 'Редактировать',
                        action: 'copy'
                    },
                    {
                        title: 'Копировать',
                        action: 'copy'
                    },*/
                    {
                        title: 'В избранное',
                        action: 'checkLists/setFavorite'
                    },
                    {
                        title: 'Удалить',
                        action: 'checkLists/deleteList',
                        needConfirm: true,
                        textConfirm: "Вы уверены, что хотите удалить чек-лист?"
                    },
                ]
            }
        },
        computed: {
            list: {
                get() {
                    return this.branchList;
                },
                set(value) {
                    this.$store.commit('checkLists/setPersonalBranches', value)
                }
            },
            getOptions() {
                return {
                    animation: 200,
                    forceFallback: true
                }
            }
        },
        methods: {
            ...mapActions('checkLists',[
                'getList'
            ]),
            closeClick() {
                this.$emit('update:active', false)
            },
            hideClick() {
                this.$emit('update:full-screen')
            },
            changeList(e, index) {
                //console.log('change Branche')
                //console.log(e);
                let val = Object.assign([],this.value);
                val.splice(index, 1, e);
                this.$emit('input', val)

            },
            handleListClick(id) {
                if (this.listClick) {
                    this.getList(id);
                    this.$router.push({path: '/check-lists/' + id}).catch(() => {
                        //console.log(err);
                    })
                }
            }

        },
    }
</script>

<style scoped>
    /*.branch-list {
        max-width: 1120px;
        margin-top: 20px;
    }*/
</style>
